// import RepositoryFactory from "@/apis";
// const Quote = RepositoryFactory.quote;
import Quote from "../../apis/mantra";

export default {
  AddQuote({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Quote.AddQuote(payload);
        commit("ADD_QUOTE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getQuoteData({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Quote.getQuoteData(payload);

        commit("getQuoteData", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  removeQuote({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Quote.removeQuote(payload);
        commit("DELETE_QUOTE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editQuote({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Quote.editQuote(payload);
        commit("EDIT_MANTRA", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
